// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ErrorComponent_errorContainer__3onKE","button":"ErrorComponent_button__2lLcv"};